import Vue from "vue";
import { Provider } from "js/crossword/types";
import OS from "framework/utils/OS";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";
import SettingsList from "./SettingsList";

import styles from "../css/SettingsPopup.module.css";
declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    settings: Object,
    hideLayoutOptions: Boolean,
  },
  methods: {
    closeAndSetToDefault() {
      this.$emit("setDefaultSettings");
      this.$emit("close");
    },
    onResize(div: HTMLDivElement) {
      if (!OS.desktop) {
        div.style.width = "100%";
        div.style.transform = "translate(-50%, 0)";
        div.style.top = "0%";
        return;
      }

      const scrollView = this.$refs.scrollView as HTMLDivElement;

      scrollView.style.height = "";
      scrollView.classList.remove(styles.scrollView_active);
      div.style.transform = "translate(-50%, -50%)";

      const scaleX = Math.min(1, window.innerWidth / (div.clientWidth * 1.1));

      if (scaleX !== 1) {
        div.style.transform = `translate(-50%, -50%) scale(${scaleX})`;
      }

      const overflowY = Math.floor(div.clientHeight * 1.1 * scaleX - window.innerHeight);

      if (overflowY > 0) {
        scrollView.classList.add(styles.scrollView_active);
        scrollView.style.height = `${scrollView.clientHeight - overflowY}px`;
      }
    },
  },
  render() {
    return (
      <PopupContainer
        customClasses={[styles.container]}
        handleResize={this.onResize}
        handleClose={() => sdkHandler.trigger('interstitialAd', { callback: function() {
                this.$emit("close");
              }}, this)}
      >
          <div class={styles.scrollView} ref="scrollView">
            <SettingsList settings={this.settings} hideLayoutOptions={this.hideLayoutOptions}/>
          </div>
  
          <div class={styles.spacer}></div>        
  
          <PopupButtons buttons={[{
            label: this.localization.get("Set to default"),
            onClick: this.closeAndSetToDefault,
          }]} />

        <div class={styles.version}>{
          //@ts-ignore
          `v1.19.1`
        }</div>
      </PopupContainer>
    );
  },
});
